<template>
    <b-list-group-item class="assessment__item" :href="'/assessments/' + assessment.id" @click.prevent="select">
        <h2>{{assessment.name}}</h2>
        <small>{{ $t(status) }}<template v-if="duration"> - {{ duration }}</template><template v-if="status === 'early' && startDate"><br>{{ $t('unlocks') + ' ' + startDate }}</template><template v-if="expiry"><br>{{$t('expires') + ' ' + expiry}}</template></small>
    </b-list-group-item>
</template>
<script>

import ReadableTime from '../common/getReadableTime';
import ReadableDuration from '../common/getReadableDuration';
import AssessmentService from '../services/AssessmentService';
import checkTime from '../common/getCheckTime';

const ALERT_CONFIG = {
    expired: {
        titleKey: 'assessmentExpiredTitle',
        messageKey: 'lateAssessment'
    },
    exited: {
        titleKey: 'assessmentAlreadyExitedTitle',
        messageKey: 'security-issue'
    },
    submitted: {
        titleKey: 'assessmentAlreadySubmittedTitle',
        messageKey: 'completedAssessmentError'
    },
    started: {
        titleKey: 'assessmentAlreadyStartedTitle',
        messageKey: 'startedError'
    },
    default: {
        titleKey: 'assessmentNotOpenTitle',
        messageKey: 'earlyAssessment'
    }
};

export default {
    name: 'AssessmentBlock',
    props: {
        assessment: {
            required: true
        }
    },
    data(){
        return {
            startDate: null,
            duration: null,
            status: null,
            expiry: null
        }
    },
    mounted(){
        if (this.assessment.trigger === 'Admin Triggered' && this.assessment.trigger_prop){
            this.startDate = ReadableTime.getReadableTime(this.assessment.trigger_prop);
        }
        const readableDurationArr = ReadableDuration.getReadableDuration(this.assessment.duration);
        if (readableDurationArr) {
            this.duration = readableDurationArr[0] + ' ' + this.$t(readableDurationArr[1]);
        }
        this.status = this.assessment.status;
        if (this.assessment.trigger_prop){
            this.expiry = checkTime.getExpiryDate(this.assessment.trigger_prop, {'days': 30});
        }
        if (this.assessment.status == 'Enrolled' && this.assessment.trigger_prop){
            const checkWindow = checkTime.getOutsideWindow(this.assessment.trigger_prop, {'days': 30});
            if (checkWindow === 'Expired'){
                AssessmentService.updateStatus(this.assessment.id, checkWindow);
                this.status = 'Expired';
            } else if (checkWindow === 'Early') {
                this.status = 'Early';
            }
        } else if (this.assessment.status == 'Started') {
            if (this.$store.getters.getAssessment === this.assessment.id && this.$store.getters.getSecureAssessment){
                AssessmentService.updateStatus(this.assessment.id, 'Exited')
                .then(() => {
                    this.$store.dispatch('clearAssessment', this.assessment.id);
                });
                this.status = 'exited';
            } else {
                this.status = 'started';
            }
        } else if (this.assessment.status == 'Exited') {
            this.status = 'exited';
            if (this.$store.getters.getAssessment === this.assessment.id){
                this.$store.dispatch('clearAssessment', this.assessment.id);
            }
        } else if (this.assessment.status == 'Expired'){
            this.status = 'expired';
        } else if (this.assessment.status != 'Submitted' && this.assessment.status.startsWith('Submitted')){
            this.status = 'submitted'
        }
        this.status = this.status.toLowerCase();
    },
    methods: {
        getAlertConfig() {
            return ALERT_CONFIG[this.status] || ALERT_CONFIG.default;
        },
        showToast(messageKey) {
            const { titleKey } = this.getAlertConfig();

            this.$bvToast.toast(this.$t(messageKey), {
                title: this.$t(titleKey),
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: 5000,
                appendToast: false,
                variant: 'primary',
                id: '' + this.assessment.id,
                solid: true
            });
        },
        openAssessment() {
            this.$router.push('/assessments/' + this.assessment.id);
        },
        select() {
            if (this.status === 'enrolled') {
                this.openAssessment();
                return;
            }

            if (this.status === 'started' && !this.$store.getters.getSecureAssessment) {
                this.openAssessment();
                return;
            }

            const { messageKey } = this.getAlertConfig();
            this.showToast(messageKey);
        }
    }
}

</script>
